<page-title text="Password Reset | BitOasis" i18n-text="@@pageTitle.resetPassword"></page-title>
<site-layout class="narrow push">
  <h2 class="text-center text-header text-bold mb-2" i18n="@@front.resetPassword.title">Reset Your Password</h2>
  <p class="text-lg text-center" i18n="@@front.resetPassword.subtitle">Account password reset</p>
  <div class="p-3"></div>

  <auth-reset-password></auth-reset-password>
</site-layout>
